import { Avatar, Col, Dropdown, Icon, Layout, Menu, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import logo from '../../images/logoEricson.png';
import logoGrd from '../../images/logoEricsonLateral.png';
import { LoopBackConfig } from '../../sdk';
import * as Services from '../../sdk/services';
import { LoopBackAuth } from '../../sdk/services';
import { validarAcessoToken } from '../acesso-sistema/redux/actions';
import * as actions from './redux/actions';

const { path: backendPath } = LoopBackConfig;
const menuOpcoes = (
  <Menu>
    <Menu.Item>
      <Link to={'/signout'}>
        <Icon type="logout" /> Sair
      </Link>
    </Menu.Item>
  </Menu>
);

const { Header, Content, Footer, Sider } = Layout;

export class MasterPage extends Component {
  static propTypes = {
    masterPage: PropTypes.object.isRequired,
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  openMenu(url) {
    this.props.history.push(`${url}`);
  }
  constructor() {
    super();
    this.state = {
      autenticado: false
    };
  }

  async componentDidMount() {
    const { acessoSistema, history } = this.props;
    const { validarAcessoToken } = this.props.actionsAuth;
    const primeiroAcesso = await localStorage.getItem('primeiroAcesso');

    try {
      const urlQuery = new URLSearchParams(history.location.search);
      const accessToken = urlQuery.get('access-token');
      const auth = new LoopBackAuth();

      if (accessToken) {
        const objToken = {
          id: accessToken,
          userId: urlQuery.get('user-id'),
          rememberMe: true,
          ttl: 1209600,
          created: new Date(),
        }
        auth.setToken(objToken);
      }
      const UsuarioApi = new Services['UsuarioApi']();
      const token = UsuarioApi.getCurrentToken();
      if (!token || !token.id) {
        window.location.replace(`${backendPath}/api/auth/azureadoauth2`);
      } else {
        if (!acessoSistema.accessTokens.id) {
          let dataProfileUser = await UsuarioApi.sincronizarIdentidadePerfil(token.userId);

          if (!dataProfileUser || !dataProfileUser.CodigoPerfil) {
            history.push('/acesso-negado2');
          }
          const FuncionarioApi = new Services['FuncionarioApi']();
          const PessoaApi = new Services['PessoaApi']();

          // let pessoa = await UsuarioApi.findById(token.userId, { include: ['UsuarioPerfil'] });
          let pessoa = await PessoaApi.findById(token.userId, { include: ['UsuarioPerfil', 'Funcionario'] });
          let funcionario = await FuncionarioApi.find({ where: { RA_MAT: pessoa.Matricula } });
          validarAcessoToken({ pessoa: { ...pessoa }, usuario: { ...token }, funcionario: { ...funcionario[0] } });
          this.setState({ autenticado: true, visibleBoasVindas: !primeiroAcesso });
        } else {
          this.setState({ autenticado: true, visibleBoasVindas: !primeiroAcesso });
        }
        localStorage.setItem('primeiroAcesso', true);
      }

    } catch (error) {
      //LobrapApi.SaveLog( error, 'Exception');
      console.error(error);
      window.location.replace(`${backendPath}/api/auth/azureadoauth2`);
      // history.push(`/acesso-negado`);
    }
  }

  logout = () => {
    this.props.actionsAuth.logout(action => {
      if (action === 'ACESSO_SISTEMA_LOGOUT_SUCCESS') {
        localStorage.clear();
        this.props.history.push('/');
      }
    });
  };

  render() {
    const { menu } = this.props.masterPage;
    const { toogleMenu } = this.props.actions;
    const { acessoSistema } = this.props;
    const { autenticado } = this.state;
    const { pathname } = this.props.history.location;

    return !autenticado || !acessoSistema.usuario.UsuarioPerfil ? (
      <div className="portal-master-page">
        <Spin
          spinning={!autenticado}
          size="large"
          tip="Aguarde..."
          className="load"
          style={{ minHeight: '100vh' }}
        />
      </div>
    ) : (
      <Spin spinning={!autenticado} size="large" tip="Aguarde..." className="load">
        <Layout className={pathname.toString().replace('/', '')} style={{ minHeight: '100vh' }}>
          <Sider
            width={250}
            collapsed={!menu.open}
            trigger={null}
            style={{ overflow: 'auto' }}
            collapsedWidth={0}
            breakpoint="lg"
            onBreakpoint={broken => {
              this.props.actions.onBreakpoint(broken);
            }}
            onCollapse={(collapsed, type) => {
              this.props.actions.toogleMenu();
              //   console.log(collapsed, type);
            }}
          >
            <div className="logo" style={{ textAlign: 'center' }}>
              <img src={!!menu.open ? logoGrd : logo} style={{ width: '80%' }} alt="logo sistema" />
            </div>
            <Menu theme="dark" mode="inline">
              {/* <Menu.Item key="home" >
                <Icon type="home" />
                <span className="nav-text"> Home</span>
                <Link to={`/`} />
              </Menu.Item> */}

              <Menu.SubMenu
                key="cadastros"
                title={
                  <span>
                    {' '}
                    <Icon type="tool" />
                    <span>Configuração</span>
                  </span>
                }
              >
                <Menu.Item key="cadastros-8">
                  <span className="nav-text"> Impersonate SAP </span>
                  <Link to="/login-sap/impersonate" />
                </Menu.Item>
              </Menu.SubMenu>

              {acessoSistema.usuario.UsuarioPerfil.perfilAdministrador && (
                <Menu.SubMenu
                  key="logs"
                  title={
                    <span>
                      <Icon type="history" />
                      <span>Consulta de Logs</span>
                    </span>
                  }
                >
                  <Menu.Item key="logs-rpa">
                    <span className="nav-text"> Logs RPA SAP</span>
                    <Link to="/logs-sistema/logs-rpa" />
                  </Menu.Item>
                </Menu.SubMenu>
              )}

              {acessoSistema.usuario.UsuarioPerfil.perfilAdministrador && (
                <Menu.SubMenu
                  key="usuarios"
                  title={
                    <span>
                      <Icon type="team" />
                      <span>Usuários</span>
                    </span>
                  }
                >
                  <Menu.Item key="usuarios-3">
                    <span className="nav-text"> Perfil de Usuários </span>
                    <Link to="/usuario-perfil/listar" />
                  </Menu.Item>
                </Menu.SubMenu>
              )}
              <Menu.Divider />
              <Menu.Item key="usuario-logout">
                <Icon type="logout" />
                <span className="nav-text"> Sair</span>
                <Link to="/logout" />
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout>
            <Header style={{ background: '#fff' }}>
              <Row end="xs" justify="space-between" type="flex">
                <Col>
                  <Icon
                    className="trigger"
                    type={false ? 'menu-unfold' : 'menu-fold'}
                    onClick={toogleMenu}
                  />
                </Col>
                <Col className="componentesMaster">
                  {/* <Badge count={99} >
                  <Button type="primary" shape="circle" icon="notification" size="small" />
                </Badge> */}
                  <Dropdown overlay={menuOpcoes} placement="bottomLeft">
                    <span>
                      <Avatar icon="user" />
                      <span> {this.props.acessoSistema.usuario.nomeCompleto} </span>
                    </span>
                  </Dropdown>
                </Col>
              </Row>
            </Header>
            <Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
              <div style={{ padding: 24, background: '#fff', textAlign: 'center' }}>
                {this.props.children}
              </div>
            </Content>
            <Footer style={{ textAlign: 'center' }}>InnovSoftware</Footer>
          </Layout>
        </Layout>
      </Spin>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    masterPage: state.masterPage,
    acessoSistema: state.acessoSistema,
    router: state.router,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...validarAcessoToken }, dispatch),
    actionsAuth: bindActionCreators({ validarAcessoToken }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MasterPage);



// WEBPACK FOOTER //
// ./src/features/master-page/MasterPage.js